import React from 'react';
import ReactDOM from 'react-dom/client';
import './homeinsuranceinfoBirthdate.css';


function HomeInsuranceBirthdate({formData, handleChange}) {

  
    return (
      <div className="homequoteinfo-Birthdate">
      <div className='homequoteinfo-birthdate-abc'>
      <div className='birthdate-abc-a'>
          <p id='birthdate-abc-a'>A</p>
          <p id='birthdate-abc-address'>Address</p>
        </div>
        <div className='birthdate-abc-b'>
          <p id='birthdate-abc-b'>B</p>
          <p id='birthdate-abc-birthdate'>Birthdate</p>
        </div>
        <div className='birthdate-abc-c'>
          <p id='birthdate-abc-c'>C</p>
          <p id='birthdate-abc-contact'>Contact Info</p>
        </div> 
      </div>
      <div className='birthdateinputs'>
      <input
        type="text"
        id="month"
        name="month"
        value={formData.month}
        onChange={(e) => handleChange('month', e.target.value)}
        placeholder='MM'
        required
        pattern="^(0[1-9]|1[0-2])$"
        title="Enter month as two digits: 01-12"
        maxLength={2}
      />
      <input
        type="text"
        id="day"
        name="day"
        value={formData.day}
        onChange={(e) => handleChange('day', e.target.value)}
        placeholder='DD'
        required
        pattern="^(0[1-9]|[12][0-9]|3[01])$"
        title="Enter day as two digits: 01-31"
        maxLength={2}
      />
      <input
        type="text"
        id="year"
        name="year"
        value={formData.year}
        onChange={(e) => handleChange('year', e.target.value)}
        placeholder='YYYY'
        required
        pattern="^[0-9]{4}$"
        title="Enter year as four digits: 1900-2099"
        maxLength={4}
      />
      </div>
        

      </div>
    );
  }
  
  export default HomeInsuranceBirthdate;